module.exports = __webpack_public_path__ + "img/qr_code_wxx.3a81091b.jpg";